import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { EPublicApiEndpoint, TRequestDiagnostics, TRequestSource } from './types';

type TPublicApiLogMetaParams = {
  endpoint: EPublicApiEndpoint;
  source: TRequestSource;
  diagnostics?: TRequestDiagnostics;
  parameters?: object;
  statusCode?: number;
  error?: unknown;
  /** Порядковый номер отказа в этой загрузке страницы */
  errorIndex?: number;
};

/**
 * Достаёт код ответа из ошибки: http-api бросает HttpBadStatusCodeError на коды,
 * не объявленные в swagger-схеме ручки, поэтому 401 приходит именно так
 */
function getStatusCodeFromError(error: unknown): number | null {
  return HttpBadStatusCodeError.isLike(error) ? error.statusCode : null;
}

/**
 * Собирает мета-данные обращения к публичной ручке чатов для записи в лог
 */
export function getPublicApiLogMeta({
  endpoint,
  source,
  diagnostics,
  parameters,
  statusCode,
  error,
  errorIndex,
}: TPublicApiLogMetaParams): TRequestDiagnostics {
  return {
    microserviceName: 'chats',
    pathApi: endpoint,
    source,
    statusCode: statusCode === undefined ? getStatusCodeFromError(error) : statusCode,
    errorIndex: errorIndex === undefined ? null : errorIndex,
    errorMessage: error instanceof Error ? error.message : null,
    parameters: parameters ? JSON.stringify(parameters) : null,
    ...diagnostics,
  };
}
